import { SVGProps } from "react";

const ClipboardListIcon = (props: SVGProps<SVGSVGElement>) => {
  const { color, ...rest } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="clipboardListTitle"
      {...rest}
    >
      <title id="clipboardListTitle">Clipboard List</title>
      <path d="M13.4 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V12.6" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 6H6" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 10H6" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 14H6" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 18H6" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.378 5.62603C21.7763 5.22767 22.0001 4.68739 22.0001 4.12403C22.0001 3.56067 21.7763 3.02038 21.378 2.62203C20.9796 2.22367 20.4393 1.99988 19.876 1.99988C19.3126 1.99988 18.7723 2.22367 18.374 2.62203L13.364 7.63403C13.1262 7.87165 12.9522 8.16536 12.858 8.48803L12.021 11.358C11.9959 11.4441 11.9944 11.5353 12.0166 11.6221C12.0389 11.7089 12.084 11.7882 12.1474 11.8516C12.2108 11.915 12.2901 11.9601 12.3769 11.9824C12.4637 12.0046 12.5549 12.0031 12.641 11.978L15.511 11.141C15.8336 11.0468 16.1274 10.8728 16.365 10.635L21.378 5.62603Z" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default ClipboardListIcon;
